<script setup lang="ts">
  import HttpError from '@leaflink/stash/HttpError.vue';
  import { onMounted } from 'vue';

  import { useErrorPage } from '@/composables/useErrorPage';
  import { useAuthStore } from '@/piniaStores/auth/auth.store';

  const emit = defineEmits<{
    (e: 'mount'): void;
  }>();

  const errorPage = useErrorPage();
  const authStore = useAuthStore();

  onMounted(() => {
    emit('mount');
  });
</script>

<template>
  <div>
    <HttpError
      v-if="errorPage.isVisible"
      v-bind="errorPage.settings"
      class="tw-h-screen"
      @logout="errorPage.settings?.onLogout || authStore.logout()"
    />
    <router-view v-else />
  </div>
</template>
